export const errorMessages = {
    '5xx': 'An unknown error occurred. Please reload the page to continue. We apologize for the inconvenience.',
    418: 'You have been blocked - contact Direct Hedge',
    419: "You don't have permissions to make this operation",
    420: 'Order was already accepted, probably by someone else',
};



// WEBPACK FOOTER //
// ./source/constants/errorMessages.js